import { useEffect, useState } from 'react';
import { type RewardsResponse, RewardsResponse as RewardsSchema } from '@veylme/shared';

import { apiFetch } from '../api/client.js';

export type RewardsState =
  | { status: 'loading' }
  | { status: 'ok'; data: RewardsResponse }
  | { status: 'error' };

/**
 * Хук получения наград текущего юзера (GET /me/rewards).
 * Fail-soft: ошибка → status:'error', UI показывает fallback без краша.
 */
export function useRewards(): RewardsState {
  const [state, setState] = useState<RewardsState>({ status: 'loading' });

  useEffect(() => {
    apiFetch('/me/rewards', { parse: RewardsSchema })
      .then((data) => setState({ status: 'ok', data }))
      .catch(() => setState({ status: 'error' }));
  }, []);

  return state;
}

/** Иконка бейджа для отображения в UI (языко-нейтральна — эмодзи). */
export const BADGE_ICONS: Record<string, string> = {
  viral_starter: '🔥',
  storyteller: '📖',
  loop_master: '🏆',
};
